import React from "react";
import { Accordion, Col } from "react-bootstrap";
import "../assets/css/Sidebar.css";
import { CreateMenus, IMenu, IMenus, SidebarItem } from "./";

interface ISidebar {
  isSmall?: boolean
  userType: string | undefined;
  adsStatus: string;
}

export const Sidebar: React.FC<ISidebar> = ({ isSmall, userType, adsStatus }) => {
  const columnSize = !isSmall ? { xs: 2, sm: 2, md: 3, lg: 2 } : { xs: 12, sm: 12, md: 12, lg: 12 };
  const availableMenu = userType === 'true' ? 'subscriberMenu' : userType === 'manager' ? 'managerMenu' : 'unsubscriberMenu';

  const menus: IMenus = CreateMenus(adsStatus, isSmall);

  return (
    <Col
      xs={columnSize.xs}
      sm={columnSize.sm}
      md={columnSize.md}
      lg={columnSize.lg}
      className={`d-flex justify-content-between flex-column ${!isSmall ? `d-none d-md-inline-flex` : null}`}
    >
      <Accordion defaultActiveKey="0" style={{ paddingTop: 20 }}>
        {menus[availableMenu].map((menuItem: IMenu, index) =>
          <SidebarItem
            key={index.toString()}
            ekey={index.toString()}
            icon={menuItem.icon}
            label={menuItem.label}
            items={menuItem.items}
            {...(menuItem.action ? { onClick: menuItem.action } : null)}
            onNavigate={menuItem.url}
            isSmall={isSmall}
          />
        )}
      </Accordion>
    </Col>
  );
}
